import { PanelSpinner } from '@vkontakte/vkui';
import { classNames } from '@vkontakte/vkjs';
import { QrCodeFallbackLoadingProps } from './types';
import { defaultQrSize } from './consts';
import styles from './QrCodeBase.module.css';

/**
 * Компонент загрузки qrCode
 * @param size - размер qrCode
 */
export function QrCodeFallbackLoading(props: QrCodeFallbackLoadingProps) {
  const { size = defaultQrSize, className } = props;

  return (
    <div className={classNames(styles.root, styles.root__isLoading, className)} style={{ width: size, height: size }}>
      <PanelSpinner size="m" />
    </div>
  );
}
